import { type FC, memo } from "react";
import { Button, ButtonKind, ButtonSize, ButtonVariant, Text } from "@stubhub/broadway-web";
import { Content } from "src/shared/components/content";
import {
  bottomButtonContainer,
  fullWidthButton,
} from "src/website-apps/responsive/stubhub-performer/components/calendar/styles";

interface Props {
  resetFilters: () => void;
}

export const MobileCalendarNoResults: FC<Props> = memo(({ resetFilters }) => (
  <>
    <Text variant="label" size="small">
      <Content id="cid$#4000951#" /> {/* No events within your filters. */}
    </Text>
    <div className={bottomButtonContainer}>
      <Button
        kind={ButtonKind.Neutral}
        variant={ButtonVariant.Outline}
        size={ButtonSize.Small}
        onClick={resetFilters}
        classes={{ root: fullWidthButton }}
      >
        <Content id="cid$#3637096#" />
      </Button>
    </div>
  </>
));

MobileCalendarNoResults.displayName = "MobileCalendarNoResults";
